import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Icon, IconButton, Input, withStyles } from '@material-ui/core'
import { useMutation } from 'react-apollo'
import uuid from 'uuid'
import { getTranslation, Translate } from 'src/translation'
import { ReduxState } from 'src/store/reducers'
import history from 'src/history'
import { userCommandGQL, userCommandVariables } from 'src/gql/userCommand'
import Spinner from './Spinner'
import { ErrorDialog } from './ErrorDialog'

interface SearchMenuProps {
  tubeColor: string
  classes: {
    search: string
    homepageSearchIcon: string
  }
  translate: Translate
  isInMainToolbar: boolean
  hidetoolbarsearch: boolean
}

const SearchMenu = (props: SearchMenuProps) => {
  const { tubeColor, classes, translate, isInMainToolbar, hidetoolbarsearch } = props
  const [isSearching, setIsSearching] = useState(false)
  const [search, setSearch] = useState('')
  const [errorMessage, setErrorMessage] = useState()
  const isHomePage = window.location.pathname === '/home'
  const isOnAIChatPage = window.location.pathname.startsWith('/ai-chat/')

  const [addAssistedSearchComment] = useMutation(userCommandGQL)

  const shouldHideToolbarSearch = hidetoolbarsearch && isHomePage && isInMainToolbar

  const onSearchChange = (e) => {
    setSearch(e.target.value)
  }

  const onSearchPress = async (e) => {
    if (e.type === 'keypress' && e.key !== 'Enter') return
    if (search.trim() === '') return

    if (!isSearching) {
      setIsSearching(true)

      const taskId = uuid.v4()

      history.push(`/ai-chat/${taskId}?search=${encodeURIComponent(search.trim())}`)

      addAssistedSearchComment(
        userCommandVariables({
          type: 'addAssistedSearchComment',
          payload: {
            comment: search,
            taskId
          }
        })
      ).catch((error) => {
        console.error('Failed to add assisted search comment:', error)
        const message = error?.networkError?.result?.message || error?.message || 'Unknown error'
        console.error('Error details:', message)
      })
    }
  }

  if (isOnAIChatPage && isInMainToolbar) {
    return null
  }

  return (
    <>
      <div
        style={{
          display: shouldHideToolbarSearch ? 'none' : 'flex',
          height: isInMainToolbar ? 'unset' : '65px',
          borderRadius: isInMainToolbar ? 5 : 50
        }}
        className={classes.search}
      >
        <Input
          id="search"
          placeholder={translate('assisted-search-input-placeholder') as string}
          className="pl-16 w-full"
          disableUnderline={true}
          value={search}
          onChange={onSearchChange}
          onKeyPress={onSearchPress}
        />

        <IconButton
          id="search-btn"
          className={!isInMainToolbar ? classes.homepageSearchIcon : ''}
          onClick={onSearchPress}
        >
          {!isSearching ? <Icon>search</Icon> : <Spinner tubeColor={tubeColor} variant="tube" />}
        </IconButton>
      </div>
      <ErrorDialog open={Boolean(errorMessage)} message={errorMessage} onClose={() => setErrorMessage(null)} />
    </>
  )
}
const mapStateToProps = (state: ReduxState) => ({
  tubeColor: state.auth.tube.color,
  translate: getTranslation(state.translation.lang),
  hidetoolbarsearch: state.toolbar.hidetoolbarsearch
})

const styles = () => ({
  search: {
    border: '1px solid #c4c4c4',
    backgroundColor: '#fff',
    margin: 10,
    width: '97%',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden'
  },
  homepageSearchIcon: {
    height: '100px',
    width: '65px',
    backgroundColor: '#fafafa',
    borderRadius: 0,
    borderLeft: '1px solid #c4c4c4'
  }
})

export default connect(mapStateToProps)(withStyles(styles)(SearchMenu))
